import * as Yup from 'yup';
import { getTranslatedString } from 'helpers/i18n';

export const PurchaseOrderSchema = Yup.object().shape({
  vendor_id: Yup.string().required(getTranslatedString('required')),
  required_date: Yup.string().required(getTranslatedString('required')),
  property_id: Yup.string().required(getTranslatedString('required')),
  title: Yup.string()
    .required(getTranslatedString('required'))
    .max(50, 'Must be less than 50 characters'),
  description: Yup.string()
    .required(getTranslatedString('required'))
    .max(250, 'Must be less than 250 characters'),
  purchase_order_items: Yup.array().required(
    getTranslatedString('landlordPortal.addPurchaseOrderDrawer.pleaseAddPurchaseOrderItem')
  ),
});
